import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import configMenu from '../configMenu.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { guid } from '@/utils';
export default {
  components: {
    uploadFile: uploadFile,
    draggable: draggable,
    pictureLibrary: pictureLibrary,
    configMenu: configMenu
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    tabListFlat: Array,
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      updateIndex: 0,
      depot: {},
      example_pic: require('@/assets/banner_header_example.jpg'),
      defaultValue: {
        imageurl: '',
        link_type: '1',
        link_value: '',
        goods_id: '',
        module_plate_id: '',
        sort: '',
        theme_color: '#C20C0C'
      }
    };
  },
  methods: {
    changeIndicatorStyle: function changeIndicatorStyle(id) {
      this.value.config.indicator_style = id;
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path,
        _data$theme_color = data.theme_color,
        theme_color = _data$theme_color === void 0 ? '#C20C0C' : _data$theme_color;
      this.value.config.value[this.updateIndex]['imageurl'] = path;
      this.value.config.value[this.updateIndex]['theme_color'] = theme_color;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      this.$refs.uploadBanner[index].uploadBanner();
    },
    addUpload: function addUpload() {
      this.value.config.value.push(_objectSpread(_objectSpread({}, this.defaultValue), {}, {
        uid: guid()
      }));
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.imageurl = "".concat(this.$ossurl).concat(res);
    },
    //删除图片
    handleDelUpload: function handleDelUpload(index) {
      var _this2 = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config.value.splice(index, 1);
      }).catch(function () {});
    }
  },
  created: function created() {
    var _this3 = this;
    if (!this.value.config_default_value) {
      var defaultConfig = this.tabListFlat.find(function (i) {
        return i.key === _this3.value.key;
      });
      this.$set(this.value, 'config_default_value', JSON.parse(JSON.stringify(defaultConfig.config_default_value)));
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$in = _this$value$config.indicator_style,
      indicator_style = _this$value$config$in === void 0 ? 1 : _this$value$config$in,
      _this$value$config$pa = _this$value$config.padding_lr,
      padding_lr = _this$value$config$pa === void 0 ? 0 : _this$value$config$pa;
    this.$set(this.value, 'config', _objectSpread({
      width: '750',
      height: '280',
      value: [_objectSpread(_objectSpread({}, this.defaultValue), {}, {
        uid: guid()
      })],
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index,
      //兼容新老组件 默认预置2
      indicator_style: indicator_style,
      //兼容新老组件 默认预置1
      padding_lr: padding_lr
    }, this.value.config));
    this.value.config.value = this.value.config.value.map(function (i) {
      return _objectSpread({
        theme_color: '#C20C0C',
        // 后增属性，对旧数据预设默认值
        uid: guid()
      }, i);
    });
    this.getPicture();
  }
};